<template>
  <div class="example-tree">
    <div class="w-100 d-flex justify-content-between flex-row-reverse">
      <div class="d-flex justify-content-around align-items-center editingIconDiv">
        <i class="fa-light fa-trash-can me-2" data-bs-toggle="tooltip" title="حذف" @click="$bvModal.show(`${selected != null ? 'deleteModal' : 'cancelModal'}`)"></i>
        <i class="fa-light fa-pencil me-3" data-bs-toggle="tooltip" title="ویرایش" @click="categoriesAction = 1"></i>
        <DropdownButton @dropdownSelected="modalType = $event.id" />
      </div>
      <div class="searchCategoriesDiv position-relative">
        <input type="text" class="searchCategoriesInput ps-4" v-model="treeFilter" />
        <i class="fa-regular fa-magnifying-glass fa-flip-horizontal"></i>
      </div>
    </div>
    <Tree
      v-if="showTree"
      ref="tree"
      :data="treeData"
      :options="treeOptions"
      @node:selected="border"
      @node:expanded="onNodeExpand"
      :filter="treeFilter"
      @tree:mounted="onTreeMounted"
      class="tree-highlights"
    >
      <div slot-scope="{ node }" class="d-flex justify-content-between align-content-center w-100 focusChildNode" :style="`${calcBorderRight(node)}`">
        <div class="d-flex align-items-center">
          <i
            :class="[!node.expanded() ? 'fa fa-plus' : 'fa fa-minus']"
            :style="`color:rgba(1, 36, 205,${calcColor(node)});visibility:${!node.hasChildren() ? 'hidden' : ''}`"
            class="customMargin"
          ></i>
          <template v-if="!node.hasChildren()">
            <img v-if="node.data.icon" width="60" height="50" class="imgBorder" :src="node.data.icon" />
            <img v-else width="60" height="50" class="imgBorder defaultImg" src="../../assets/images/default-category.svg" />
            <span> {{ node.text }} </span>
          </template>

          <template v-else>
            <img v-if="node.data.icon" width="60" height="50" class="imgBorder" :src="node.data.icon" />
            <img v-else width="60" height="50" class="imgBorder defaultImg" src="../../assets/images/default-category.svg" />
            <span>
              {{ node.text }}
            </span>
          </template>
        </div>
        <div class="d-flex flex-row-reverse float-left catActions align-items-center" v-if="node.selected()">
          <div class="d-flex align-items-center" data-bs-toggle="tooltip" title="حذف"><i class="fa-light fa-trash-can" @click.stop.self="$bvModal.show('deleteModal')"></i></div>
          <div class="d-flex align-items-center" data-bs-toggle="tooltip" title="ویرایش"><i class="fa-light fa-pencil fa-sm" @click.stop.self="categoriesAction = 1"></i></div>
          <div class="d-flex align-items-center" data-bs-toggle="tooltip" title="ویژگی‌های دسته‌بندی" v-if="!node.hasChildren()"><i class="fa-regular fa-align-right" @click.stop.self="pushToFormBuilder(node.data.categoryId)"></i></div>
          <div v-if="node.depth < 9 && node.data.formId === null" class="d-flex align-items-center" data-bs-toggle="tooltip" title="اضافه کردن زیردسته"><i class="fa fa-plus" @click.stop.self="modalType = 1"></i></div>
          <div class="d-flex align-items-center" v-if="!node.hasChildren()">
            <router-link :to="`/varieties/${node.data.categoryId}`"><img src="../../assets/images/Vector.png" data-bs-toggle="tooltip" title="مدیریت تنوع" alt="Vector"/></router-link>
          </div>
        </div>
      </div>
    </Tree>
    <template v-else>
      <Loader />
    </template>
    <b-modal id="addModal" centered hide-footer v-model="showModal" :title="`اضافه کردن ${isChild ? 'زیر' : ''} دسته بندی`">
      <b-col class="d-flex justify-content-start align-items-end" lg="5" style="margin: 0 0 35px 0">
        <img v-if="newCategoryData.image" width="90" height="60" :src="newCategoryData.image" />
        <img v-else src="@/assets/images/default-pic.svg" width="90" height="60" />
        <div @click="$bvModal.show('chooseImage')" class="choosePic">انتخاب عکس</div>
        <b-modal id="chooseImage" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title>
          <div class="p-3">
            <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="productImage($event)" />
          </div>
        </b-modal>
      </b-col>
      <template v-if="isChild">
        <SetCategory
          @loadMoreData="loadMorecategory"
          @searchedItem="searchedCategory"
          :searchedData="searchedCategoryData"
          @selectedItem="selectedCategory"
          :selectedValue="selectCategory"
          pagination
          placeholder="دسته بندی اصلی"
          title="دسته بندی اصلی"
        />
      </template>
      <BaseInput
        @input="newCategoryData.title = $event"
        inputType="text"
        classes="my-2"
        title="عنوان"
        placeholder="عنوان"
        :maxlength="30"
        :value="newCategoryData.title"
        required
        :showError="categoryTitleError"
        errortext="وارد کردن عنوان دسته‌بندی الزامیست!"
      />
      <TextArea @input="newCategoryData.desc = $event" inputType="text" classes="my-2" title="توضیحات" placeholder="توضیحات" :value="newCategoryData.desc" />
      <div class="mt-3 float-right w-100">
        <div class="d-flex align-items-center justify-content-end bModalBtnDiv">
          <Button @click.native="showModal = false" text="انصراف" btnClass="btn-border cancel" />
          <Button @click.native="submitModal(selected)" text="ثبت" btnClass="ms-2 aprove btn-border" :loading="btnLoading" />
        </div>
      </div>
    </b-modal>
    <b-modal id="cancelModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="@/assets/images/checked1.svg" />
        </div>
        <div class="error-title text-center">{{ cancelModalData }}</div>
        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button
              class="col-6"
              variant="secondary"
              block
              @click="
                $bvModal.hide('cancelModal')
                flushData()
              "
              >انصراف</b-button
            >
            <b-button
              class="ms-2 col-6"
              variant="primary"
              block
              @click="
                $bvModal.hide('cancelModal')
                flushData()
              "
              >متوجه شدم</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="deleteModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="@/assets/images/checked1.svg" />
        </div>
        <div class="error-title text-center">آیا از حذف دسته‌بندی مورد نظر اطمینان دارید؟</div>
        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button
              class="col-6"
              variant="secondary"
              block
              @click="
                $bvModal.hide('deleteModal')
                flushData()
              "
              >خیر</b-button
            >
            <b-button class="ms-2 col-6" variant="primary" block @click="categoriesAction = 0">بله</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <Toast :title="toastText" :error="toastMode" :showToast="showToast" />
  </div>
</template>
<script>
import categoriesDataProvider from '../../services/categories.js'
import fileMannager from '../../services/file'
import LiquorTree from 'liquor-tree'
import DropdownButton from './Button.vue'
import Button from '../common/Button.vue'
import ImageCropper from '../user/ImageCropper.vue'
import BaseInput from '../common/form/formModules/BaseText.vue'
import TextArea from '../common/form/formModules/TextAreaInput.vue'
import SetCategory from '../common/form/formModules/ComboBox.vue'
import Loader from '../common/loader.vue'
import Toast from '../common/Toast.vue'

export default {
  components: {
    Tree: LiquorTree,
    DropdownButton,
    Button,
    ImageCropper,
    BaseInput,
    TextArea,
    SetCategory,
    Loader,
    Toast,
  },
  data() {
    return {
      cropperLoading: false,
      treeOptions: {
        propertyNames: {
          text: 'name',
          id: 'guid',
          desc: 'description',
        },
        filter: {
          emptyText: 'موردی یافت نشد!',
        },
      },
      treeSort: {
        recursive: false,
      },
      btnLoading: false,
      cancelModalData: 'لطفا دسته بندی مورد نظر خود را انتخاب کنید.',
      selectCategoryException: false,
      selected: null,
      showTree: true,
      treeData: [],
      treeFilter: '',
      mockCategoryData: [],
      selectCategory: '',
      selectedCategoryId: null,
      searchedCategoryData: [],
      newCategoryData: {
        parentId: null,
        title: '',
        image: '',
        desc: '',
      },
      subCategoryModal: false,
      addCategoryModal: false,
      categoryTitleError: false,
      showModal: false,
      isChild: false,
      paginationData: 1,
      searchedQuery: '',
      pagination: null,
      toastText: '',
      toastMode: false,
      showToast: null,
      modalType: null /* 0 => category , 1 => subCategory */,
      categoriesAction: null /* 0 => delete , 1 => edit */,
    }
  },
  methods: {
    pushToFormBuilder(payload) {
      this.$router.push(`categories/formBuilder/detail/${payload}`)
    },
    calcBorderRight(node) {
      return `border-right-color:rgba(1, 36, 205,${this.calcColor(node)}`
    },
    calcColor(node) {
      return Math.pow(node.depth, 1) == 0 ? 1 : 1 - node.depth / 9.5
    },
    sort() {},
    customSort(order) {
      const persianLocale = 'fa-IR'
      function sort(node0, node1) {
        return node0.text.localeCompare(node1.text, persianLocale)
      }
      this.$refs.tree.sortTree(sort)
    },
    onTreeMounted() {
      this.treeSort.recursive = true
    },
    sortTree(data) {
      this.$refs.tree.sortTree(data)
    },
    onNodeExpand(node) {
      const expandedNodes = this.$refs.tree.findAll({ state: { expanded: true } })
      expandedNodes.forEach(expandedNode => {
        if (expandedNode.id !== node.id && node.depth === expandedNode.depth) {
          expandedNode.collapse()
        }
      })
    },
    editNode(node, data) {
      node.data.text = data
      node.data.icon = this.newCategoryData.image
      node.data.description = this.newCategoryData.desc
      this.getData()
      setTimeout(() => {
        this.customSort()
      }, 200)
      this.toastText = 'دسته‌بندی مورد نظر با موفقیت ویرایش شد.'
      this.toastMode = false
      this.showToast = true
      setTimeout(() => {
        this.flushToast()
      }, 2002)
    },
    removeNode(node) {
      node.remove()
      this.toastText = 'دسته بندی مورد نظر با موفقیت حذف گردید.'
      this.toastMode = false
      this.showToast = true
      setTimeout(() => {
        this.flushToast()
      }, 2002)
    },
    addNode(data) {
      this.$refs.tree.after({
        text: this.newCategoryData.title,
        data: { categoryId: data.id,description: this.newCategoryData.desc, icon: this.newCategoryData.image, guid: data.guid, formId:null },
      })
      this.customSort()
      this.toastText = 'دسته‌بندی مورد نظر با موفقیت ثبت شد.'
      this.toastMode = false
      this.showToast = true
      setTimeout(() => {
        this.flushToast()
      }, 2002)
    },
    addChildNode(node, data) {
      node.append({
        text: this.newCategoryData.title,
        data: { categoryId: data.id,description: this.newCategoryData.desc, icon: this.newCategoryData.image, guid: data.guid, formId:null },
      })
      this.customSort()
      this.toastText = 'زیر دسته‌بندی مورد نظر با موفقیت ثبت شد.'
      this.toastMode = false
      this.showToast = true
      setTimeout(() => {
        this.flushToast()
      }, 2002)
    },
    border(node) {
      this.selected = node
    },
    selectedCategory(cat) {
      this.selectCategory = cat.value
      this.selectedCategoryId = cat.key
    },
    searchedCategory(event) {
      this.searchedQuery = event
      let temp = {
        query: event,
        pageNumber: 1,
        pageSize: 10,
      }
      this.getCategoryList(temp, 1)
    },
    addCategory(data) {
      let reqData = null
      reqData = {
        parentId: this.isChild ? data.data.categoryId : 0,
        name: this.newCategoryData.title,
        icon: this.newCategoryData.image,
        description: this.newCategoryData.desc,
      }
      categoriesDataProvider
        .createProductCategory(reqData)
        .then(res => {
          if (!this.isChild) {
            this.addNode(res.data.data)
          } else if (this.isChild) {
            this.addChildNode(this.selected, res.data.data)
          }
          this.btnLoading = false
          this.flushData()
        })
        .catch(err => {
          this.flushData()
          this.btnLoading = false
          this.toastText = 'خطایی رخ داده است لطفا دوباره سعی کنید.'
          this.toastMode = true
          this.showToast = true
          setTimeout(() => {
            this.flushToast()
          }, 2002)
          return false
        })
    },
    editCategory(data) {
      let reqData = {
        parentId: this.isChild ? this.selectedCategoryId : 0,
        guid: data.data.guid,
        name: this.newCategoryData.title,
        icon: this.newCategoryData.image,
        description: this.newCategoryData.desc,
      }
      categoriesDataProvider
        .editCategory(reqData)
        .then(res => {
          this.editNode(data, reqData.name)
          this.flushData()
        })
        .catch(err => {
          this.btnLoading = false
          return false
        })
    },
    deleteCategory(data) {
      let reqData = {
        guid: data.data.guid,
      }
      categoriesDataProvider
        .deleteCategory(reqData)
        .then(res => {
          if (res.status === 200) {
            this.removeNode(data)
            this.$bvModal.hide('deleteModal')
            this.flushData()
          }
        })
        .catch(err => {
          if (err.response.status === 400) {
            this.$bvModal.hide('deleteModal')
            this.cancelModalData = 'دسته‌بندی انتخاب شده دارای محصول می‌باشد و قابل حذف شدن نیست!'
            setTimeout(() => {
              this.$bvModal.show('cancelModal')
            }, 300)
            const tree = this.$refs.tree
            tree.unselectAll()
            tree.selected().unselect()
            tree.selectAll()
          }
          return false
        })
      this.flushData()
    },
    submitModal(data) {
      this.categoryTitleError = false
      this.btnLoading = true
      if (this.newCategoryData.title.length == 0) {
        this.categoryTitleError = true
        this.btnLoading = false
        return
      }
      if (this.categoriesAction != null) {
        this.editCategory(data)
      } else {
        this.addCategory(data)
      }
    },
    productImage(data) {
      this.cropperLoading = true
      fileMannager.addImage({ base64image: data }).then(res => {
        this.newCategoryData.image = res.data.data.downloadUrl
        this.$bvModal.hide('chooseImage')
        this.cropperLoading = false
      })
    },
    flushToast() {
      this.toastText = ''
      this.toastMode = false
      this.showToast = null
    },
    flushData() {
      this.modalType = null
      this.isChild = null
      this.selectCategory = ''
      this.newCategoryData = {
        parentId: null,
        title: '',
        image: '',
        desc: '',
      }
      this.subCategoryModal = false
      this.addCategoryModal = false
      this.showModal = false
      this.categoriesAction = null
      this.searchedCategoryData = []
      this.paginationData = 1
      this.categoryTitleError = false
      this.btnLoading = false
    },
    getData() {
      this.showTree = false
      categoriesDataProvider
        .getCustomCategories()
        .then(res => {
          this.treeData = res.data.data.productCategories
          if (res.status === 200) {
            this.showTree = true
            this.btnLoading = false
          }
        })
        .catch(err => {})
    },
    getCategoryList(data, situation) {
      // situation === 0 ? pagination : situation === 1 ?
      categoriesDataProvider.getCategoryList(data).then(res => {
        this.pagination = res.data.pagination
        let temp = res.data.data.categories
        if (temp.length > 0) {
          for (let i = 0; i < temp.length; i++) {
            temp[i].value = temp[i]['categoryName']
            temp[i].key = temp[i]['categoryId']
            delete temp[i].categoryName
            delete temp[i].categoryId
            if (i === temp.length - 1) {
              this.showTree = true
              if (situation === 1) {
                this.searchedCategoryData = temp
              } else if (situation === 0) {
                this.searchedCategoryData.push(...temp)
              }
            }
          }
        } else {
          this.searchedCategoryData = temp
          return
        }
      })
    },
    loadMorecategory() {
      if (this.searchedCategoryData.length < this.pagination.totalCount) {
        this.paginationData += 1
        let temp = {
          query: this.searchedQuery,
          pageNumber: this.paginationData,
        }
        this.getCategoryList(temp, 0)
      } else {
        return
      }
    },
  },
  watch: {
    modalType(val) {
      if (val === 0) {
        this.isChild = false
        this.showModal = true
      } else if (val == 1) {
        let selection = this.$refs.tree.findAll({ state: { select: true } })
        if (selection.tree.selectedNodes[0].depth < 9) {
          if (selection.tree.selectedNodes.length === 0) {
            this.$bvModal.show('cancelModal')
            return
          } else {
            this.isChild = true
            this.newCategoryData.title = ''
            this.newCategoryData.image = ''
            this.newCategoryData.desc = ''
            let temp = { key: selection.tree.selectedNodes[0].data.categoryId, value: selection.tree.selectedNodes[0].data.text }
            setTimeout(() => {
              this.selectedCategory(temp)
              this.searchedCategoryData = [temp]
            }, 300)
            this.showModal = true
          }
        } else {
          this.cancelModalData = 'سقف مجاز اضافه کردن زیردسته رعایت نشده است.'
          setTimeout(() => {
            this.$bvModal.show('cancelModal')
          }, 300)
        }
      }
    },
    categoriesAction(val) {
      let selection = this.$refs.tree.findAll({ state: { select: true } })
      if (selection.tree.selectedNodes.length === 0) {
        this.$bvModal.show('cancelModal')
        this.categoriesAction = null
        return
      } else if (val === 0) {
        this.deleteCategory(selection.tree.selectedNodes[0])
      } else if (val === 1) {
        this.newCategoryData.title = selection.tree.selectedNodes[0].data.text
        this.newCategoryData.image = selection.tree.selectedNodes[0].data.icon
        this.newCategoryData.desc = selection.tree.selectedNodes[0].data.description
        if (selection.tree.selectedNodes[0].parent != null) {
          this.isChild = true
          let temp = {
            key: selection.tree.selectedNodes[0].parent.data.categoryId,
            value: selection.tree.selectedNodes[0].parent.data.text,
          }
          setTimeout(() => {
            this.selectedCategory(temp)
            let temp2 = {
              query: this.selectCategory,
              pageNumber: 1,
              pageSize: 10,
            }
            this.getCategoryList(temp2, 1)
          }, 300)
        } else {
          this.isChild = false
        }
        this.showModal = true
      }
    },
    showModal(val) {
      if (val === false) {
        this.flushData()
      }
      if (val === true && this.categoriesAction === 1 && this.isChild) {
        this.getCategoryList()
      }
    },
    ['treeSort.recursive'](order) {
      this.customSort(order)
    },
  },
  beforeMount() {
    this.getData()
  },
}
</script>
<style scoped lang="scss">
@import './style.scss';
</style>
